<script setup lang="ts">
interface Props {
  email: string;
  password: string;
  passwordConfirmation: string;
  error: string | null;
}

interface Emits {
  (e: 'update:email', value: string): void;
  (e: 'update:password', value: string): void;
  (e: 'update:passwordConfirmation', value: string): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="space-y-5">
    <div>
      <label for="email" class="block text-sm text-[#F5F0EA] mb-2">
        {{ $t('signup_step_account.email_label') }}
      </label>
      <input
        type="email"
        id="email"
        required
        :value="email"
        @input="emit('update:email', ($event.target as HTMLInputElement).value)"
        class="w-full px-4 py-3 bg-[#18181C] border border-[#2A2018] rounded-2xl focus:bg-[#1E1E23] focus:ring-2 focus:ring-[#D4956A] focus:border-transparent outline-none transition text-[#F5F0EA] placeholder:text-[#524840]"
        :placeholder="$t('signup_step_account.email_placeholder')"
      />
    </div>
    <div>
      <label for="password" class="block text-sm text-[#F5F0EA] mb-2">
        {{ $t('signup_step_account.password_label') }}
      </label>
      <input
        type="password"
        id="password"
        required
        minlength="8"
        :value="password"
        @input="emit('update:password', ($event.target as HTMLInputElement).value)"
        class="w-full px-4 py-3 bg-[#18181C] border border-[#2A2018] rounded-2xl focus:bg-[#1E1E23] focus:ring-2 focus:ring-[#D4956A] focus:border-transparent outline-none transition text-[#F5F0EA] placeholder:text-[#524840]"
        :placeholder="$t('signup_step_account.password_placeholder')"
      />
      <p class="mt-2 text-xs text-[#524840]">
        {{ $t('signup_step_account.password_hint') }}
      </p>
    </div>
    <div>
      <label for="passwordConfirmation" class="block text-sm text-[#F5F0EA] mb-2">
        {{ $t('signup_step_account.confirm_password_label') }}
      </label>
      <input
        type="password"
        id="passwordConfirmation"
        required
        minlength="8"
        :value="passwordConfirmation"
        @input="emit('update:passwordConfirmation', ($event.target as HTMLInputElement).value)"
        class="w-full px-4 py-3 bg-[#18181C] border border-[#2A2018] rounded-2xl focus:bg-[#1E1E23] focus:ring-2 focus:ring-[#D4956A] focus:border-transparent outline-none transition text-[#F5F0EA] placeholder:text-[#524840]"
        :placeholder="$t('signup_step_account.confirm_password_placeholder')"
      />
    </div>
    <div
      v-if="error"
      class="p-4 bg-red-900/20 border border-red-800/40 rounded-xl text-red-400 text-sm"
    >
      {{ error }}
    </div>
  </div>
</template>
